import React, { useState, useEffect } from 'react';
import {
	Grid,
	TextField,
	Box,
	makeStyles,
	FormControlLabel,
	Radio,
	RadioGroup,
	FormControl,
	Popper,
	Hidden,
	useMediaQuery,
	useTheme,
} from '@material-ui/core';
import Autocomplete from '@mui/material/Autocomplete';
// import flt from '../assets/images/flt.png';
import { useDispatch, useSelector } from 'react-redux';
import DateRangeNew from '../components/reusableComponents/DateRangeNew';
import BodyText from '../components/reusableComponents/BodyText';
import { Form, Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import {
	SearchReturnFormDispatch,
	SearchFormDispatch,
	fetchCityDispatch,
	SearchEtravFormDispatch,
	SearchTripjackFormDispatch,
	SearchReturnEtravFormDispatch,
	AddSearchFlightDispatch,
} from '../reducers/HomeReducer';
// import Typed from 'typed.js';
import SwapHorizontalCircleIcon from '@mui/icons-material/SwapHorizontalCircle';
import DesktopDateNew from '../components/reusableComponents/DesktopDateNew';
import {
	setSelectedDepart,
	setSelectedOrigin,
	setSelectedTrip,
	setselectedFDSector,
} from '../reducers/UiReducer';
import DesktopDateFd from '../components/reusableComponents/DestopDateFd';
import { fdSearchDispatch, searchSuccess } from '../reducers/FDReducer';
import ModifyDateFd from '../components/reusableComponents/ModifyDateFd';
const useStyles = makeStyles((theme) => ({
	root: {
		'& .MuiFormControl-root': {
			'& div': {
				'& div': {
					display: 'none',
				},
			},
		},
		'& .MuiInput-underline:before': {
			borderBottom: 'none',
		},
		'& .MuiInput-underline:after': {
			borderBottom: 'none',
		},
		'& input': {
			fontSize: 14,
			fontWeight: 600,
			padding: '0px 4px 4px 0px',
			color: 'black',
		},
		'& .MuiInput-underline:hover:not(.Mui-disabled):before': {
			borderBottom: 'none',
		},
		'& .MuiInput-underline:after': {
			borderBottom: 'none',
		},

		'& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon.css-184whfw-MuiAutocomplete-root .MuiAutocomplete-inputRoot':
			{
				paddingRight: 0,
			},
		'& .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon.css-xzqck1-MuiAutocomplete-root .MuiAutocomplete-inputRoot':
			{
				paddingRight: 0,
			},
		// '& div': {
		// 	'& div': {
		// 		'& div': {
		// 			paddingRight: 0,
		// 		},
		// 	},
		// },
	},
	radio: {
		'& .MuiRadio-root': {
			color: 'grey',
		},
		'& .MuiRadio-colorSecondary.Mui-checked': {
			color: '#f50057',
		},
		'& .MuiTypography-body1': {
			color: 'black',
			fontSize: '14px',
			//   fontWeight: 800,
		},
	},
	radio2: {
		'& .MuiRadio-root': {
			color: 'black',
		},
		'& .MuiRadio-colorSecondary.Mui-checked': {
			color: '#f50057',
		},
		'& .MuiTypography-body1': {
			color: 'black',
			fontSize: '14px',
			// fontWeight: 800,
		},
	},
	popper: {
		'& .MuiAutocomplete-listbox': {
			'& :hover': {
				color: 'rgb(239, 51, 57)',
				// '& img': {
				// 	background: 'rgb(239, 51, 57)',
				// },
			},
		},
	},
}));
const Modifyfdform = () => {
	const [result, setResult] = useState([]);
	const [result2, setResult2] = useState([]);
	const classes = useStyles();
	const { city } = useSelector((state) => state.home);
	const { fdsector } = useSelector((state) => state.promo);
	const { agentlogin } = useSelector((state) => state.user);
	const [filterData, setFilterData] = useState('');
	const handleRadio = (event) => {
		setValue(event.target.value);
	};
	const history = useHistory();
	const dispatch = useDispatch();
	const [adult, setAdult] = useState(1);
	const [child, setChild] = useState(0);
	const [infant, setInfant] = useState(0);
	const [toggle, setToggle] = useState(false);
	const [total, SetTotal] = useState(adult + child + infant);
	const [value, setValue] = useState('Economy');
	const [leaving, setLeaving] = useState('DEL');
	const [trip, setTrip] = useState('oneway');
	const [going, setGoing] = useState('CCU');
	const [from, setFrom] = useState(null);
	const [to, setTo] = useState(null);
	const {
		origin,
		depart,
		OriginO,
		selectedOrigin,
		selectedDepart,
		tripInfo,
		selectedFDSector,
		fddate,
	} = useSelector((state) => state.ui);
	const theme = useTheme();
	const matches = useMediaQuery(theme.breakpoints.down('sm'));
	// const el = React.useRef(null);
	// // Create reference to store the Typed instance itself
	// const typed = React.useRef(null);
	// React.useEffect(() => {
	// 	const options = {
	// 		strings: ['Book Flights And Explore The World With Us'],
	// 		typeSpeed: 50,
	// 		backSpeed: 50,
	// 		// loop: true,
	// 	};

	// 	// elRef refers to the <span> rendered below
	// 	typed.current = new Typed(el.current, options);

	// 	// return () => {
	// 	// 	// Make sure to destroy Typed instance during cleanup
	// 	// 	// to prevent memory leaks
	// 	// 	typed.current.destroy();
	// 	// };
	// }, []);
	// console.log('total', adult + child + infant);
	// console.log('Adult', adult);
	// console.log('Child', child);
	// console.log('Infant', infant);
	const handleSubmit = (data) => {
		// console.log(data);
		let org = data.Origin;
		let des = data.Destination;
		let formData = {
			Origin: selectedFDSector.origin,
			Destination: selectedFDSector.destination,
			DepartureDate: fddate,
			AdultCount: adult,
			ChildCount: child,
			InfantCount: infant,
			AirlineCode: '',
			agent_id: agentlogin
				? agentlogin.status === 200
					? agentlogin?.result.result.id
					: 0
				: 0,
			// agent_id: agentlogin&&agentlogin.status===200 ? agentlogin && agentlogin.result.result.id : 0,
		};
		let formData2 = {
			AdultCount: adult,
			ChildCount: child,
			InfantCount: infant,
			DirectFlight: false,
			OneStopFlight: false,
			JourneyType: 2,
			PreferredAirlines: null,
			Segments: [
				{
					Origin: selectedOrigin.airport_code,
					Destination: selectedDepart.airport_code,
					FlightCabinClass: 1,
					PreferredDepartureTime: origin,
					// PreferredArrivalTime: '2022-03-18',
				},
				{
					Origin: selectedDepart.airport_code,
					Destination: selectedOrigin.airport_code,
					FlightCabinClass: 1,
					PreferredDepartureTime: depart,
					// PreferredArrivalTime: '2022-03-18',
				},
			],
			Sources: 'WEB',
			agent_id: agentlogin
				? agentlogin.status === 200
					? agentlogin?.result.result.id
					: 0
				: 0,
		};
		if (tripInfo === 'oneway') {
			// dispatch(
			// 	SearchEtravFormDispatch(formData, history, OriginO, des, origin)
			// );
			// dispatch(SearchFormDispatch(formData, history, OriginO, des, origin));
			// dispatch(AddSearchFlightDispatch(formData));
			// dispatch(fdSearchDispatch(formData));
			dispatch(searchSuccess(null))
			dispatch(fdSearchDispatch(formData));
			
			// history.push({
			// 	pathname: `/fdoneway/${selectedFDSector.origin}/${selectedFDSector.destination}`,
			// 	state: {
			// 		body: formData,
			// 		OriginO: origin,
			// 	},
			// });
			// console.log('data', formData);
			// dispatch(
			// 	SearchTripjackFormDispatch(formData, history, OriginO, des, origin)
			// );
		} else {
			history.push({
				pathname:
					selectedOrigin.country_code === 'IN' &&
					selectedDepart.country_code === 'IN'
						? `/roundway/${selectedOrigin.airport_code}/${selectedDepart.airport_code}/${origin}/${selectedDepart.airport_code}/${selectedOrigin.airport_code}/${depart}`
						: '/international',
				state: { returnBody: formData2 },
			});
			// dispatch(
			//   SearchReturnFormDispatch(
			//     formData2,
			//     history,
			//     selectedOrigin,
			//     selectedDepart
			//   )
			// );
			// dispatch(
			//   SearchReturnEtravFormDispatch(
			//     formData2,
			//     history,
			//     selectedOrigin,
			//     selectedDepart
			//   )
			// );
			// dispatch(AddSearchFlightDispatch(formData));
			// console.log(formData2);
		}
	};
	// console.log(invoiceOptions);
	// const handleSearch = (event) => {
	// 	let value = event.target.value.toLowerCase();
	// 	let results = [];
	// 	console.log(value);
	// 	setVal(value);

	// 	results =
	// 		bookinghistoryagent &&
	// 		bookinghistoryagent.result &&
	// 		bookinghistoryagent.result.flights.filter((item) => {
	// 			return (
	// 				item.orderId.toLowerCase().includes(value.toLowerCase()) ||
	// 				item.userEmail.toLowerCase().includes(value.toLowerCase()) ||
	// 				item.origin.toLowerCase().includes(value.toLowerCase()) ||
	// 				item.destination.toLowerCase().includes(value.toLowerCase()) ||
	// 				item.flightType.toLowerCase().includes(value.toLowerCase()) ||
	// 				item.journeyType.toLowerCase().includes(value.toLowerCase()) ||
	// 				item.journeyType.toLowerCase().includes(value.toLowerCase()) ||
	// 				item.supplier.toLowerCase().includes(value.toLowerCase()) ||
	// 				item.bookingStatus.toLowerCase().includes(value.toLowerCase()) ||
	// 				item.travelDate.toLowerCase().includes(value.toLowerCase())
	// 			);
	// 		});
	// 	setData(results);
	// 	// console.log(results);
	// };
	const handleSearchOrigin = (event) => {
		let value = event ? event.target.value.toLowerCase() : 'del';
		let results = [];
		// console.log(value);
		results =
			fdsector &&
			fdsector.result &&
			fdsector.result.data.filter((item) => {
				return (
					item.sector.toLowerCase().includes(value.toLowerCase()) ||
					item.origin.toLowerCase().includes(value.toLowerCase()) ||
					item.destination.toLowerCase().includes(value.toLowerCase())
				);
			});
		console.log('searchresult', results);
		if (event) {
		} else {
			dispatch(setselectedFDSector(results ? results[0] : null));
		}
		if (results?.length < 80) {
			setFilterData(results);
		}
	};
	const handleChangeTrip = (e) => {
		// console.log(e.target.value);
		dispatch(setSelectedTrip(e.target.value));
	};
	useEffect(() => {
		handleSearchOrigin();
	}, []);
	const PopperMy = function (props) {
		return (
			<Popper
				{...props}
				style={styles.popper}
				className={classes.popper}
				placement='bottom-start'
			/>
		);
	};

	const styles = (theme) => ({
		popper: {
			width: 'fit-content',
		},
	});
	return (
		<>
			<Formik
				initialValues={{
					Origin: '',
					Destination: '',
				}}
				validate={(values) => {
					const errors = {};
				}}
				onSubmit={handleSubmit}>
				{({ submitForm, isSubmitting, setFieldValue, values }) => (
					<>
						<Form
							style={{
								// background: 'white',
								marginTop: matches ? '45px' : '0px',
								paddingLeft: 20,
								paddingRight: 20,
								// boxShadow: '-1px 3px 5px 0 rgb(0 0 0 / 16%)',
							}}>
							<Box className={classes.radio}>
								{/* <FormControl onChange={handleChangeTrip}>
                  <RadioGroup
                    row
                    aria-labelledby="demo-row-radio-buttons-group-label"
                    name="row-radio-buttons-group"
                  >
                    <FormControlLabel
                      value="oneway"
                      control={
                        <Radio checked={tripInfo == "oneway" ? true : false} />
                      }
                      label="ONE WAY"
                    />
                    <FormControlLabel
                      value="roundtrip"
                      control={
                        <Radio
                          checked={tripInfo == "roundtrip" ? true : false}
                        />
                      }
                      label="ROUND TRIP"
                    />
                  </RadioGroup>
                </FormControl> */}
							</Box>
							<Grid
								container
								spacing={2}
								alignItems='self-end'
								style={{ marginBottom: 0, marginTop: 40,alignItems:'self-end' }}
								// style={{ marginTop: 10 }}
							>
								<Grid item xs={12} md={12} lg={tripInfo == 'roundtrip' ? 4 : 5}>
									<Grid container alignItems='center' spacing={2}>
										{/* Date Picker Starting */}
										<Grid
											item
											xs={12}
											lg={6}
											style={{ display: 'flex', alignItems: 'center' }}>
											<div className={classes.root} style={{ width: '100%' }}>
												{/* <span style={{ color: 'white' }}>Leaving From</span> */}
												<Autocomplete
													id='country-select-demo'
													sx={{
														background: "white",
														border: '1px solid lightgrey',
														// borderRadius: '4px',
														padding: '7px',
														transition: 'none',
														color:'black'
													}}
													clearOnBlur={true}
													value={selectedFDSector}
													PopperComponent={PopperMy}
													options={
														filterData && filterData.length > 0
															? filterData
															: []
													}
													filterOptions={(options, state) => options}
													autoHighlight
													getOptionLabel={(option) =>
														`${option.sector.split('//')[0]}${option.origin} `
													}
													renderOption={(props, option) => (
														<Box
															// mr={'5px'}
															component='li'
															sx={{ '& > img': { mr: 2 } }}
															{...props}>
															<img
																loading='lazy'
																width='20'
																src='https://cdn-icons-png.flaticon.com/512/3125/3125713.png'
																alt=''
															/>
															<p style={{ fontSize: 17, marginLeft: 5 }}>
																{`${option.sector.split('//')[0]}
																${option.origin} // ${option.sector.split('//')[1]}
																${option.destination}`}
															</p>
														</Box>
													)}
													onChange={(event, value) => {
														// setFieldValue('Origin', value.airport_code);
														// dispatch(setSelectedOrigin(value));
														// setFrom(value);
														dispatch(setselectedFDSector(value));
														console.log('value', value);
													}}
													renderInput={(params) => (
														<TextField
															{...params}
															onChange={handleSearchOrigin}
															name='origin'
														/>
													)}
												/>
											</div>
											{/* <Hidden only={["xs", "sm"]}>
                        <SwapHorizontalCircleIcon
                          onClick={() => {
                            setTo(from);
                            dispatch(setSelectedOrigin(to));
                            dispatch(setSelectedDepart(from));
                            setFrom(to);
                          }}
                          style={{
                            color: "white",
                            width: "2em",
                            height: "2em",
                            marginTop: 20,
                            cursor: "pointer",
                          }}
                        />
                      </Hidden> */}
										</Grid>
										<Grid item xs={12} lg={6}>
											<div className={classes.root}>
												{/* <span style={{ color: 'white' }}>Going To</span> */}
												<Box
													style={{
														border: '1px solid lightgrey',
														padding: '7px',
														// borderRadius: '4px',
														background:'white'
													}}>
													<span style={{ fontWeight: 'bold', color: 'black' }}>
														{`${selectedFDSector?.sector.split('//')[1]} ${
															selectedFDSector?.destination
														} `}
													</span>
												</Box>
												{/* <Autocomplete
													id='country-select-demo'
													sx={{
														border: '1px solid lightgrey',
														borderRadius: '4px',
														padding: '7px',
														transition: 'none',
													}}
													clearOnBlur={true}
													options={selectedFDSector ? selectedFDSector : []}
													value={selectedFDSector}
													PopperComponent={PopperMy}
													filterOptions={(options, state) => options}
													autoHighlight
													getOptionLabel={(option) =>
														`${option.sector.split('//')[1]}${
															option.destination
														} `
													}
													renderOption={(props, option) => (
														<></>
														// <Box
														// 	// mr={'5px'}
														// 	component='li'
														// 	sx={{ '& > img': { mr: 2 } }}
														// 	{...props}>
														// 	<img loading='lazy' width='20' src={flt} alt='' />
														// 	<p style={{ fontSize: 16 }}>
														// 		{option.city_name} ({option.airport_code}){' '}
														// 		{option.airport_name}
														// 	</p>
														// </Box>
													)}
													onChange={(event, value) => {
														// setFieldValue('Destination', value.airport_code);
														// console.log(value.airport_code);
														// dispatch(setSelectedDepart(value));
														// setTo(value);
													}}
													renderInput={(params) => (
														<TextField
															{...params}
															// onChange={handleSearchOrigin}
														/>
													)}
												/> */}
											</div>
										</Grid>
										{/* Date Picker Ending */}
									</Grid>
								</Grid>
								<Grid
									item
									xs={12}
									md={12}
									lg={
										tripInfo == 'oneway' ? 2 : tripInfo == 'roundtrip' ? 4 : 2
									}>
									<Box display='flex' justifyContent='space-between'>
										
									</Box>
									{tripInfo == 'oneway' ? (
										<ModifyDateFd/>
									) : tripInfo == 'roundtrip' ? (
										<DateRangeNew />
									) : (
										<DesktopDateFd />
									)}
								</Grid>
								{/* Travellers Strating */}
								<Grid item xs={12} md={6} lg={tripInfo == 'oneway' ? 3 : 2}>
									<ul
												class='menu'
												style={{
													// marginTop: 20,
													borderRadius: 2,
													paddingLeft: 0,
													cursor: 'pointer',
													background: 'white',
													// width: trip == "roundtrip" ? "110%" : "95%",
												}}>
												<li>
													<div
														onClick={() =>
															toggle ? setToggle(false) : setToggle(true)
														}
														style={{
															padding: 7,
															fontSize: matches ? 12 : 15,
															// borderRadius: 4,
															overflow: 'hidden',
															whiteSpace: 'nowrap',
															textOverflow: 'ellipsis',
															fontWeight: 600,
															border: '1px solid lightgrey',
															textAlign: 'center',
														}}>
														Travellers,Classes
													</div>

													{toggle ? (
														<>
															{' '}
															<ul
																style={{
																	padding: 5,
																	width: '77%',
																	height: 250,
																}}>
																<li>
																	<Box
																		style={{ padding: 5 }}
																		display='flex'
																		justifyContent='space-between'
																		textAlign='center'
																		alignItems='center'>
																		<BodyText
																			four
																			textStyle={{
																				color: 'black',
																				fontSize: 16,
																				fontWeight: 500,
																			}}>
																			Adult
																		</BodyText>
																		<Box display='flex' alignItems='center'>
																			<Box
																				style={{
																					cursor: 'pointer',
																					background: 'rgb(0, 55, 114)',
																					padding: '0px 10px',
																					borderRadius: '5px',
																				}}
																				onClick={() =>
																					adult === 0 ? '' : setAdult(adult - 1)
																				}>
																				<BodyText
																					textStyle={{
																						fontSize: 16,
																						color: 'white',
																					}}>
																					-
																				</BodyText>
																			</Box>
																			<Box
																				ml={'15px'}
																				style={{
																					cursor: 'pointer',
																					background: 'rgb(0, 55, 114)',
																					padding: '0px 10px',
																					borderRadius: '5px',
																				}}>
																				<BodyText
																					textStyle={{
																						fontSize: 16,
																						color: 'white',
																					}}>
																					{adult}
																				</BodyText>
																			</Box>
																			<Box
																				ml={'15px'}
																				style={{
																					cursor: 'pointer',
																					background: 'rgb(0, 55, 114)',
																					padding: '0px 10px',
																					borderRadius: '5px',
																				}}
																				onClick={() =>
																					adult + child + infant === 9
																						? adult
																						: setAdult(adult + 1)
																				}>
																				<BodyText
																					textStyle={{
																						fontSize: 16,
																						color: 'white',
																					}}>
																					+
																				</BodyText>
																			</Box>
																		</Box>
																	</Box>
																</li>
																<li>
																	<Box
																		style={{ padding: 5 }}
																		display='flex'
																		justifyContent='space-between'
																		textAlign='center'
																		alignItems='center'>
																		<BodyText
																			four
																			textStyle={{
																				color: 'black',
																				fontSize: 16,
																				fontWeight: 500,
																			}}>
																			Child
																		</BodyText>
																		<Box display='flex' alignItems='center'>
																			<Box
																				style={{
																					cursor: 'pointer',
																					background: 'rgb(0, 55, 114)',
																					padding: '0px 10px',
																					borderRadius: '5px',
																				}}
																				onClick={() =>
																					child === 0 ? '' : setChild(child - 1)
																				}>
																				<BodyText
																					textStyle={{
																						fontSize: 16,
																						color: 'white',
																					}}>
																					-
																				</BodyText>
																			</Box>
																			<Box
																				ml={'15px'}
																				style={{
																					cursor: 'pointer',
																					background: 'rgb(0, 55, 114)',
																					padding: '0px 10px',
																					borderRadius: '5px',
																				}}>
																				<BodyText
																					textStyle={{
																						fontSize: 16,
																						color: 'white',
																					}}>
																					{child}
																				</BodyText>
																			</Box>
																			<Box
																				ml={'15px'}
																				style={{
																					cursor: 'pointer',
																					background: 'rgb(0, 55, 114)',
																					padding: '0px 10px',
																					borderRadius: '5px',
																				}}
																				onClick={() =>
																					adult + child + infant === 9
																						? child
																						: setChild(child + 1)
																				}>
																				<BodyText
																					textStyle={{
																						fontSize: 16,
																						color: 'white',
																					}}>
																					+
																				</BodyText>
																			</Box>
																		</Box>
																	</Box>
																</li>
																<li>
																	<Box
																		style={{ padding: 5 }}
																		display='flex'
																		justifyContent='space-between'
																		textAlign='center'
																		alignItems='center'>
																		<BodyText
																			four
																			textStyle={{
																				color: 'black',
																				fontSize: 16,
																				fontWeight: 500,
																			}}>
																			Infant
																		</BodyText>
																		<Box display='flex' alignItems='center'>
																			<Box
																				style={{
																					cursor: 'pointer',
																					background: 'rgb(0, 55, 114)',
																					padding: '0px 10px',
																					borderRadius: '5px',
																				}}
																				onClick={() =>
																					infant === 0
																						? ''
																						: setInfant(infant - 1)
																				}>
																				<BodyText
																					textStyle={{
																						fontSize: 16,
																						color: 'white',
																					}}>
																					-
																				</BodyText>
																			</Box>
																			<Box
																				ml={'15px'}
																				style={{
																					cursor: 'pointer',
																					background: 'rgb(0, 55, 114)',
																					padding: '0px 10px',
																					borderRadius: '5px',
																				}}>
																				<BodyText
																					textStyle={{
																						fontSize: 16,
																						color: 'white',
																					}}>
																					{infant}
																				</BodyText>
																			</Box>
																			<Box
																				ml={'15px'}
																				style={{
																					cursor: 'pointer',
																					background: 'rgb(0, 55, 114)',
																					padding: '0px 10px',
																					borderRadius: '5px',
																				}}
																				onClick={() =>
																					adult + child + infant === 9
																						? infant
																						: setInfant(infant + 1)
																				}>
																				<BodyText
																					textStyle={{
																						fontSize: 16,
																						color: 'white',
																					}}>
																					+
																				</BodyText>
																			</Box>
																		</Box>
																	</Box>
																</li>
																<li>
																	<Box
																		style={{ padding: 10 }}
																		display='flex'
																		alignItems='center'
																		justifyContent='space-between'>
																		<Box className={classes.radio2}>
																			<FormControl component='fieldset'>
																				<RadioGroup
																					aria-label='gender'
																					name='gender1'
																					value={value}
																					color='black'
																					onChange={handleRadio}>
																					<FormControlLabel
																						value='Economy'
																						control={<Radio />}
																						label='Economy'
																					/>
																					<FormControlLabel
																						value='Business'
																						control={<Radio />}
																						label='Business'
																					/>
																					<FormControlLabel
																						value='First Class'
																						control={<Radio />}
																						label='First Class'
																					/>
																					<FormControlLabel
																						value='Premium Economy'
																						control={<Radio />}
																						label='Premium Economy'
																					/>
																				</RadioGroup>
																			</FormControl>
																		</Box>
																		<Box
																			style={{
																				background: 'darkcyan',
																				padding: 5,
																			}}
																			onClick={() => setToggle(false)}>
																			<span
																				style={{
																					color: 'white',
																					cursor: 'pointer',
																					fontSize: 12,
																				}}>
																				Done
																			</span>
																		</Box>
																	</Box>
																</li>
																{/* <li></li> */}
															</ul>
														</>
													) : (
														''
													)}
												</li>
											</ul>
								</Grid>
								{/* Travellers Ending */}

								{/* Book Button Starting */}
								<Grid item xs={12} md={6} lg={2} style={{ marginTop: 5 }}>
									<input
										type='submit'
										value='Search'
										className='btn'
										style={{
											width: '100%',
											fontSize: 14,
											// borderRadius: 4,
											backgroundColor: 'rgb(0, 87, 94)',
											padding: 8,
										}}
									/>
								</Grid>
							</Grid>
						</Form>
					</>
				)}
			</Formik>
		</>
	);
};

export default Modifyfdform;
